module.exports = __webpack_public_path__ + "images/emoji/four.0f7cdd9b70e71a17665c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/four.png
// module id = MhRQ
// module chunks = 13